// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// import { updateStatusApi } from "../Api/api";

// import classes from "./Redirect.module.css";

// const Redirect = () => {
//   const navigate = useNavigate();

//   const [param, setParam] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const queryParams = new URLSearchParams(window.location.search);

//   const params = {};

//   for (const [key, value] of queryParams.entries()) {
//     params[key] = value;
//   }

//   const UpdateMessage = async () => {
//     console.log("update message called");

//     try {
//       const data = {
//         message: params.message,
//         reason: params.error,
//         ext_ref: params.requestid,
//       };

//       const res = await axios.post(updateStatusApi, data);

//       console.log(res);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // useEffect(() => {
//   //   if (params?.message?.toLowerCase() === "success") {
//   //     UpdateMessage();
//   //     navigate("/");
//   //   } else {
//   //     UpdateMessage();
//   //   }
//   // }, []);
//   useEffect(() => {
//     const handleRedirect = async () => {
//       try {
//         await UpdateMessage();

//         if (params?.message?.toLowerCase() === "success") {
//           setTimeout(() => {
//             navigate("/");
//           }, 3000);
//         } else {
//           setLoading(false);
//         }
//       } catch (err) {
//         console.log(err);

//         setLoading(false);
//       }
//     };

//     handleRedirect();
//   }, []);

//   console.log(params, "params---------");


//   if (loading && params?.message?.toLowerCase() === "success") {

//   return (
//     <div className={classes.loaderContainer}>

//       <div className={classes.loader}></div>

//       <p className={classes.loadingText}>
//         Activating Subscription...
//       </p>

//     </div>
//   );

// }

//   return (
//     <>
//       {params?.message?.toLowerCase() === "failure" && (
//         <div className={classes.container}>
//           <div className={classes.card}>
//             {/* LOGO */}
//             <img src="/logo.png" alt="logo" className={classes.logo} />

//             {/* TITLE */}
//             <h2 className={classes.title}>Subscription Failed</h2>

//             {/* MESSAGE */}
//             <p className={classes.message}>
//               You Failed to Subscribe!!
//               <br />
//               Try Again Later!!
//             </p>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Redirect;




import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./Redirect.module.css";

const Redirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/");
  }, []);

  return (
    <div className={classes.loaderContainer}>
      <div className={classes.loader}></div>

      <p className={classes.loadingText}>Taking you home...</p>
    </div>
  );
};

export default Redirect;